/*
 * gramms LP — Header menu.
 *
 * Only the mobile dropdown needs script. From 1024px up the panel is
 * `display: contents`, so it has to stay un-hidden or the nav disappears with
 * it — which is why the resize watcher clears `hidden` rather than just
 * toggling a class.
 */
(function () {
  var DESKTOP = '(min-width: 1024px)';

  function setup(root) {
    if (!root || root.dataset.lp1HeaderReady === 'true') return;
    root.dataset.lp1HeaderReady = 'true';

    var toggle = root.querySelector('[data-lp1-header-toggle]');
    var menu = root.querySelector('[data-lp1-header-menu]');
    if (!toggle || !menu) return;

    var desktop = window.matchMedia(DESKTOP);

    function open(state) {
      toggle.setAttribute('aria-expanded', state ? 'true' : 'false');
      if (state) menu.removeAttribute('hidden');
      else menu.setAttribute('hidden', '');
    }

    function sync() {
      /* On desktop the panel is laid out by CSS and must never carry `hidden`;
         on mobile it starts closed. */
      if (desktop.matches) menu.removeAttribute('hidden');
      else open(false);
    }

    toggle.addEventListener('click', function () {
      open(toggle.getAttribute('aria-expanded') !== 'true');
    });

    /* Following an anchor leaves the panel open over the section you just
       jumped to, so close it on the way out. */
    menu.addEventListener('click', function (event) {
      if (event.target.closest('a') && !desktop.matches) open(false);
    });

    document.addEventListener('click', function (event) {
      if (desktop.matches) return;
      if (root.contains(event.target)) return;
      if (toggle.getAttribute('aria-expanded') === 'true') open(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || desktop.matches) return;
      if (toggle.getAttribute('aria-expanded') !== 'true') return;
      open(false);
      toggle.focus();
    });

    if (desktop.addEventListener) desktop.addEventListener('change', sync);
    else desktop.addListener(sync);

    sync();
  }

  function setupAll(scope) {
    Array.prototype.forEach.call(
      (scope || document).querySelectorAll('[data-lp1-header]'),
      setup
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setupAll(); });
  } else {
    setupAll();
  }

  document.addEventListener('shopify:section:load', function (event) { setupAll(event.target); });
})();
